var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardholder"},[(_vm.title)?_c('h1',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._l((_vm.resources),function(item){return _c('Card',{key:item.id,attrs:{"resource":item}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }